import { render, staticRenderFns } from "./ReturnDashboardLayout.vue?vue&type=template&id=1b71b4f5"
import script from "./ReturnDashboardLayout.vue?vue&type=script&lang=js"
export * from "./ReturnDashboardLayout.vue?vue&type=script&lang=js"
import style0 from "./ReturnDashboardLayout.vue?vue&type=style&index=0&id=1b71b4f5&prod&lang=css"
import style1 from "./ReturnDashboardLayout.vue?vue&type=style&index=1&id=1b71b4f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports